import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/home/Footer';

import styles from './styles/Legal.module.css';

const TermsOfService = () => {
    return (
        <div className={styles.legalContainer}>
            <div className={styles.legalHeader}>
                <Link to="/" className={styles.logoLink}>
                    <img
                        src="/icons/android-icon-192x192.png"
                        alt="JetChats Logo"
                        className={styles.logo}
                    />
                </Link>
                <h1>Terms of Service</h1>
                <p>Last updated: {new Date().toLocaleDateString()}</p>
            </div>

            <div className={styles.legalContent}>
                <section>
                    <h2>1. Acceptance of Terms</h2>
                    <p>Welcome to JetChats. By accessing or using our service, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.</p>
                </section>

                <section>
                    <h2>2. Description of Service</h2>
                    <p>JetChats provides a communication platform that allows users to interact with AI assistants and other users through text-based conversations. Our service may include premium features available through subscription plans.</p>
                </section>

                <section>
                    <h2>3. User Accounts</h2>
                    <p>To use certain features of our service, you must register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.</p>
                    <p>You are responsible for safeguarding the password that you use to access the service and for any activities or actions under your password. We encourage you to use "strong" passwords (passwords that use a combination of upper and lower case letters, numbers, and symbols) with your account.</p>
                </section>

                <section>
                    <h2>4. User Content</h2>
                    <p>Our service allows you to post, link, store, share and otherwise make available certain information, text, or other material. You are responsible for the content that you post to the service, including its legality, reliability, and appropriateness.</p>
                    <p>By posting content to the service, you grant us the right to use, modify, publicly perform, publicly display, reproduce, and distribute such content on and through the service. You retain any and all of your rights to any content you submit, post, or display on or through the service.</p>
                </section>

                <section>
                    <h2>5. Subscriptions</h2>
                    <p>Some parts of the service are billed on a subscription basis. You will be billed in advance on a recurring and periodic basis, depending on the type of subscription plan you select.</p>
                    <p>At the end of each period, your subscription will automatically renew under the exact same conditions unless you cancel it or we cancel it.</p>
                </section>

                <section>
                    <h2>6. Free Trial</h2>
                    <p>We may, at our sole discretion, offer a subscription with a free trial for a limited period of time. You may be required to enter your billing information to sign up for the free trial.</p>
                    <p>If you do enter your billing information when signing up for a free trial, you will not be charged by us until the free trial has expired. On the last day of the free trial period, unless you canceled your subscription, you will be automatically charged the applicable subscription fee for the type of subscription you have selected.</p>
                </section>

                <section>
                    <h2>7. Fee Changes</h2>
                    <p>JetChats, in its sole discretion and at any time, may modify the subscription fees for the subscriptions. Any subscription fee change will become effective at the end of the then-current billing cycle.</p>
                    <p>We will provide you with reasonable prior notice of any change in subscription fees to give you an opportunity to terminate your subscription before such change becomes effective.</p>
                </section>

                <section>
                    <h2>8. Refunds</h2>
                    <p>Certain refund requests for subscriptions may be considered by JetChats on a case-by-case basis and granted at the sole discretion of JetChats.</p>
                </section>

                <section>
                    <h2>9. Prohibited Uses</h2>
                    <p>You may use our service only for lawful purposes and in accordance with these Terms. You agree not to use the service:</p>
                    <ul>
                        <li>In any way that violates any applicable national, federal, state, local, or international law or regulation.</li>
                        <li>For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way.</li>
                        <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail," "chain letter," "spam," or any other similar solicitation.</li>
                        <li>To impersonate or attempt to impersonate JetChats, a JetChats employee, another user, or any other person or entity.</li>
                        <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the service, or which, as determined by us, may harm JetChats or users of the service, or expose them to liability.</li>
                    </ul>
                </section>

                <section>
                    <h2>10. Intellectual Property</h2>
                    <p>The service and its original content (excluding content provided by users), features, and functionality are and will remain the exclusive property of JetChats and its licensors. The service is protected by copyright, trademark, and other laws of both the United States and foreign countries.</p>
                    <p>Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of JetChats.</p>
                </section>

                <section>
                    <h2>11. Termination</h2>
                    <p>We may terminate or suspend your account and bar access to the service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.</p>
                    <p>If you wish to terminate your account, you may simply discontinue using the service, or delete your account within the service settings.</p>
                </section>

                <section>
                    <h2>12. Limitation of Liability</h2>
                    <p>In no event shall JetChats, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the service.</p>
                </section>

                <section>
                    <h2>13. Disclaimer</h2>
                    <p>Your use of the service is at your sole risk. The service is provided on an "AS IS" and "AS AVAILABLE" basis. The service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.</p>
                </section>

                <section>
                    <h2>14. Governing Law</h2>
                    <p>These Terms shall be governed and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.</p>
                    <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect.</p>
                </section>

                <section>
                    <h2>15. Changes to Terms</h2>
                    <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>
                    <p>By continuing to access or use our service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the service.</p>
                </section>

                <section>
                    <h2>16. Contact Us</h2>
                    <p>If you have any questions about these Terms, please contact us at support@jetchats.com.</p>
                </section>
            </div>

            <Footer />
        </div>
    );
};

export default TermsOfService;
